import React from 'react'
import Link from 'gatsby-link'
import Container from "./container";

const Header = ({ siteTitle }) => (
  <header className="header">
    <Container customClassName="header-container">
      <div className="header-logo">
        <Link to="/">
          <img src="/static/webb-holding-logo.png" />
        </Link>
      </div>
      <nav className="header-nav">
        <ul>
          <li><Link to="/">Home</Link></li>
          <li>
            <Link to="/projects">Projects</Link>
            <ul className="dropdown">    
              <li><Link className="scroll" to="/projects#abago">Abago</Link></li>
              <li><Link className="scroll" to="/projects#adwe">Adwe</Link></li>
            </ul>
          </li>
          <li>
            <Link to="/consulting">Consulting</Link>
          </li>

          {/*
            <li>
              <Link to="/news-media">News and Media</Link>
              <ul className="dropdown">
                <li><Link className="scroll" to="/news-media#courses">Courses</Link></li>
                <li><Link className="scroll" to="/news-media#blog">Blog</Link></li>
                <li><Link className="scroll" to="/news-media#gallery">Gallery</Link></li>
              </ul>
            </li>
          */}

          <li>
            <Link to="/about">About</Link>
            <ul className="dropdown">    
              <li><Link className="scroll" to="/about#company">Company</Link></li>
              <li><Link className="scroll" to="/about#testimonials">Testimonials</Link></li>
              <li><Link className="scroll" to="/about#coorporate-responsibility">Coorporate Responsibility</Link></li>
              <li><Link className="scroll" to="/about#team">Team</Link></li>
            </ul>
          </li>
          <li><Link to="/contact">Support</Link></li>
        </ul>
      </nav>
    </Container>
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js